/**
 * Internal dependencies
 */

import createConfig from 'lib/create-config';

import { CUSTOMER_SITE_PROXY_URL, CUBE_JS_PROXY_URL } from './hosts';

// ... do this better
const configApi = createConfig({
    customerSiteProxy: CUSTOMER_SITE_PROXY_URL,
    cubeJsProxy: CUBE_JS_PROXY_URL,
});

export default configApi;
